// Configures whether the node search only seaerches the label texts
// or the whole node metadata (which can be seen in a tooltip when
// hovering over a node.
// Pro fulltext:
// * All nodes matching the data are found
// Contra fulltext:
// * Nodes are found, but other than the tooltip there are no visuals indicating, why they match
// * Can be slower with large graphs.
// TODO: since in react we do not use the simple graph search anymore, this is obsolete
//       also remove the simple graph search
export const fullTextNodeSearch = true;

// Enables schema checking. Disabling is not recommended.
export const checkSchema = true;

export const constrainedSequenceForProducts = false;
export const constrainedSequenceForProductsByRevenue = false;

export const showTooltip = false;

// inclination angles for 2d and 3d vis
export const inclination2D = 90; // upright
export const inclination3D = 45; // tilted

// rotation angles for 2d and 3d vis
export const rotation2D = 0
export const rotation3D = -30;
